/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type TransferStatus = typeof TransferStatus[keyof typeof TransferStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferStatus = {
  pending: 'pending',
  success: 'success',
  void: 'void',
} as const;
